import React, { useEffect, useState } from "react";
import { Row, Col, Container, Button, Card, CardBody } from "reactstrap";
import 'toastr/build/toastr.min.css';
import * as Sentry from "@sentry/react";
import './about.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function AboutUs(props) {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false, // Permite que se disparen varias veces
    });

    AOS.refresh(); // Fuerza recalcular posiciones
  }, []);


  return (
    <div className="about-wrapper">
      {/* QUIÉNES SOMOS */}
      <section className="about-block about-bg-1" data-aos="fade-up">
        <div className="about-content">
          <h2 className="about-title center">¿Quiénes somos?</h2>
          <div className="about-row reverse">
            <div className="about-img">
              <img src="/images/asistente_ia.png" alt="Quienes somos" />
            </div>
            <div className="about-text-content">
              <p>
               En Bastet, somos una tienda dermatológica moderna dedicada al cuidado de tu piel, combinando ciencia, tecnología e innovación.
               Nuestra pasión es ofrecerte productos seleccionados por su calidad y eficacia, apoyados por un enfoque clínico y tecnológico para garantizar los mejores resultados en tu rutina de cuidado personal.
             </p>
             <p>
               Inspirados en la protección, belleza y sabiduría de la diosa Bastet, buscamos empoderarte brindando a tu rostro una piel sana, guiada por la precisión de la inteligencia artificial.
             </p>
            </div>
          </div>

          {/*Mision*/}
          <h2 className="about-title center">Misión</h2>
          <div className="about-row">
            <div className="about-img">
              <img src="/images/mision.png" alt="Misión" />
            </div>
            <div className="about-text-content">
              <p>
                Ofrecer una experiencia dermatológica innovadora y personalizada mediante el uso de inteligencia artificial, visión artificial y productos cuidadosamente seleccionados, para ayudar a cada persona a lograr una piel sana, equilibrada y radiante.
              </p>
            </div>
          </div>

          {/*Visión*/}
          <h2 className="about-title center">Visión</h2>
          <div className="about-row reverse">
            <div className="about-img">
              <img className="image_vision" src="/images/vision.png" alt="Visión"/>
            </div>
            <div className="about-text-content">
              <p>
                Convertirnos en la tienda dermatológica líder en Latinoamérica en el uso de tecnología e inteligencia artificial aplicada al análisis y cuidado de la piel, promoviendo una nueva era de atención personalizada, accesible y efectiva para todos.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
